<template>
    <div>
        <label v-if="label" :for="'form_'+name" class="form-label">{{label}}</label>
        <textarea :id="'form_'+name" class="form-control" :placeholder="placeholder" :class="{'is-invalid':hasError()}" :value="modelValue" @input="input($event.target.value)"></textarea>
        <div v-html="feedbackHtml()"></div>
    </div>
</template>
<script>
import SimpleFormElementMixin from "./SimpleFormElementMixin";

export default {
    props : {
        modelValue : {type: [String,null], required: false},
        type : {type: String, required: false, default: 'text'},
        placeholder: {type: String, required: false},
        lazy: {type: Number, required: false, default: 0},
    },
    data() {
        return {
            emitTimeOut: false
        }
    },
    computed: {
        value() {
            return this.modelValue;
        }
    },
    methods: {
        input(value) {
            if(this.lazy) {
                if(this.emitTimeOut)
                    clearTimeout(this.emitTimeOut);
                this.emitTimeOut = setTimeout(()=>{
                    this.$emit('update:modelValue', value);
                }, this.lazy);
            } else {
                this.$emit('update:modelValue', value);
            }
        }
    },
    mixins: [SimpleFormElementMixin]
}
</script>
